export default {"src":"/_next/static/media/logout.40587bb5.svg","height":18,"width":24};